import React, { FunctionComponent, useState, memo } from 'react';
import { translate } from './ProjectStatusDropDownButtonV1.translations';
import { DropDownData } from '../../../../../models';
import {
  BrassDropDownButton,
  BrassDropDownButtonProps,
} from '../../../../../components';
import { DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { ProjectStatus } from '../../../models';

interface ProjectStatusDropdownButtonV1Props extends BrassDropDownButtonProps {
  onSelectItem: (projectStatus: ProjectStatus) => void;
}

const ProjectStatusDropdownButtonV1: FunctionComponent<ProjectStatusDropdownButtonV1Props> =
  memo((props: ProjectStatusDropdownButtonV1Props) => {
    const projectStatus: DropDownData[] = Object.entries(ProjectStatus).map(
      ([text, value]) => {
        return { text: translate(text), value };
      },
    );

    const [selectedProjectStatus, setSelectedProjectStatus] = useState<DropDownData>(
      projectStatus.find((p) => p.value === ProjectStatus.ACTIVE)!,
    );

    return (
      <BrassDropDownButton
        key='ProjectStatusDropdownButtonV1'
        fillMode='outline'
        textField='text'
        items={projectStatus.filter((f) => f !== selectedProjectStatus)}
        text={selectedProjectStatus.text}
        onItemClick={(event: DropDownButtonItemClickEvent) => {
          setSelectedProjectStatus(event.item);
          props.onSelectItem(event.item.value);
        }}
        {...props}
      />
    );
  });

export { ProjectStatusDropdownButtonV1 };
export type { ProjectStatusDropdownButtonV1Props };
